/** Default locale when URL/query does not specify one (aligned with IHS / translation bundles). */
export const DEFAULT_LOCALE = 'en_GB';
